import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import API_BASE_URL from '../api';

const AlmostDone = () => {
  const [name, setName] = useState('');

  const getAuthToken = () => {
    return localStorage.getItem('stack_access_token');
  };

  useEffect(() => {
    const token = getAuthToken();
    // Fetch profile details
    fetch(`${API_BASE_URL}/api/profile/`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Stack-Access-Token': token, // Include Authentication Token in header
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json(); // Use json() to parse the response as JSON directly
      })
      .then((data) => {
        // Check if 'name' attribute exists in the data object
        if (data && data.name) {
          setName(data.name); // Set the 'name' data to state
        } else {
          setName(' ');
        }
      })
      .catch((error) => console.error('Failed to fetch name:', error));
  }, []);

  return (
    <div
      className="flex flex-col justify-between min-h-screen"
      style={{ backgroundColor: '#0D2329' }}
    >
      <Navbar />
      <main className="flex flex-col flex-grow items-center justify-center px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <p className="mt-6 text-3xl leading-7 text-white">Hello {name}!</p>
          <p className="mt-6 text-xl leading-7 text-white">Welcome to</p>
          <img
            className="col-span-40 max-h-40 w-full object-contain lg:col-span-1"
            src="logo_bigger.png"
            alt="logo"
          />
          <p className="mt-6 text-3xl leading-7 text-white">
            Your Profile Is Almost Set!
          </p>
          <p className="mt-6 text-xl leading-7 text-white">
            Fill out your interests and hobbies to complete your profile and
            start matching with singles near you!
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <a
              href="/interests-hobbies" //Add the route moving to interests/hobbies section
              style={{
                backgroundColor: '#05664f',
                color: 'white',
                textDecoration: 'none',
                padding: '10px 15px',
                borderRadius: '5px',
                display: 'inline-block',
                width: '180px',
                textAlign: 'center',
              }}
            >
              Interests/Hobbies
            </a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AlmostDone;
